import React, { useState } from "react";
import axios from "../../../api/axios";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Paper,
  Typography,
} from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

export default function CreateTemporaryStoppage() {
  const [form, setForm] = useState({
    pfno: "",
    reason: "",
    start_date: "",
    expected_resumption_date: "",
    scope: "",
    remarks: "",
  });
  const [file, setFile] = useState(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // append form fields
    Object.entries(form).forEach(([key, val]) => formData.append(key, val));

    // append file
    if (file) {
      formData.append("authority_document", file);
    }

    try {
      await axios.post("/temporary-stoppages", formData, {
        headers: { "Content-Type": "multipart/form-data" }, // ✅ important
      });

      alert("Temporary stoppage created successfully");

      // reset form
      setForm({
        pfno: "",
        reason: "",
        start_date: "",
        expected_resumption_date: "",
        scope: "",
        remarks: "",
      });
      setFile(null);
    } catch (err) {
      console.error(err.response?.data || err);
      alert("Error creating stoppage");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Grid container justifyContent="center" sx={{ p: 3 }}>
        <Grid item xs={12} md={8} lg={6}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Create Temporary Stoppage
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Fill in the details below to register a new stoppage.
            </Typography>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3} mt={1}>
                {/* PF Number */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="PF Number"
                    name="pfno"
                    value={form.pfno}
                    onChange={handleChange}
                    required
                  />
                </Grid>

                {/* Reason */}
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>Reason</InputLabel>
                    <Select
                      name="reason"
                      value={form.reason}
                      onChange={handleChange}
                      label="Reason"
                    >
                      <MenuItem value="Suspension">Suspension</MenuItem>
                      <MenuItem value="Leave Without Pay">Leave Without Pay</MenuItem>
                      <MenuItem value="Study Leave">Study Leave</MenuItem>
                      <MenuItem value="Medical Leave">Medical Leave</MenuItem>
                      <MenuItem value="Secondment">Secondment</MenuItem>
                      <MenuItem value="Others">Others</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* File Upload */}
                <Grid item xs={12}>
                  <Button variant="outlined" component="label" fullWidth>
                    Upload Authority Document
                    <input
                      type="file"
                      name="authority_document" // ✅ matches Laravel validation
                      hidden
                      accept="application/pdf,image/png,image/jpeg"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </Button>
                  {file && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {file.name}
                    </Typography>
                  )}
                </Grid>

                {/* Dates */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Start Date"
                    name="start_date"
                    value={form.start_date}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Expected Resumption Date"
                    name="expected_resumption_date"
                    value={form.expected_resumption_date}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>

                {/* Scope */}
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>Scope</InputLabel>
                    <Select name="scope" value={form.scope} onChange={handleChange} label="Scope">
                      <MenuItem value="Entire Salary">Entire Salary</MenuItem>
                      <MenuItem value="Specific Pay Items">Specific Pay Items</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Remarks */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Remarks"
                    name="remarks"
                    value={form.remarks}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Submit */}
                <Grid item xs={12} display="flex" justifyContent="flex-end">
                  <Button type="submit" variant="contained" color="success" sx={{ px: 4, py: 1.2 }}>
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>

      <Footer />
    </DashboardLayout>
  );
}
